import type { PlainText as PlainTextType } from 'types/capi/content';
import { PlainTextStyle } from 'types/capi/content';

type Props = {
  item: PlainTextType;
};

function getTextStyleClassName(style: PlainTextStyle | undefined) {
  if (style === PlainTextStyle.BOLD) return 'font-bold';
  if (style === PlainTextStyle.ITALICS) return 'italic';
}

const PlainText = ({ item }: Props) => {
  return <span className={getTextStyleClassName(item.style)}>{item.text}</span>;
};

export default PlainText;
